<div class="skeleton__wrapper">
    <div class="skeleton__title"></div>
    <div class="skeleton__text"></div>
    <div class="skeleton__text"></div>
    <div class="skeleton__text"></div>
    <div class="skeleton__text"></div>

    <div class="skeleton__title space"></div>
    <div class="skeleton__text"></div>
    <div class="skeleton__text"></div>

    <div class="skeleton__title space"></div>
    <div class="skeleton__text"></div>
    <div class="skeleton__text"></div>
    <div class="skeleton__text"></div>
    <div class="skeleton__text"></div>
</div>